/* MAHA — tooltip periódico "Contáctanos" del botón flotante de WhatsApp
   (.wa-float, ver sections/header.liquid + custom.css). Aparece cada
   ~15s y se oculta tras ~4s; en hover/foco (desktop) se muestra vía CSS
   sin depender de este script. No toca el href/número del botón. */
(function () {
  'use strict';
  if (window.__mahaWaFloatTooltipInit) return;
  window.__mahaWaFloatTooltipInit = true;

  var SHOW_INTERVAL_MS = 15000;
  var SHOW_DURATION_MS = 4000;

  function init() {
    var wrap = document.querySelector('[data-wa-float]');
    var tooltip = document.querySelector('[data-wa-float-tooltip]');
    if (!wrap || !tooltip) return;

    var hideTimer = null;

    function show() {
      tooltip.classList.add('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, SHOW_DURATION_MS);
    }
    function hide() {
      tooltip.classList.remove('is-visible');
    }

    setInterval(show, SHOW_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
